import { IsAuthenticatedGuard } from '@ip6m/server/auth';
import { Body, Controller, Delete, Get, Logger, Param, Patch, Post, Response, UseGuards } from '@nestjs/common';
import { ApiBody, ApiInternalServerErrorResponse, ApiNotFoundResponse, ApiOkResponse, ApiOperation, ApiParam, ApiTags, SwaggerModule } from '@nestjs/swagger';
import { NewServiceRequest, ServiceService } from '../../../database/services/service/service.service';



@ApiTags('service')
@Controller('/v1/service')
export class ServiceController {

    constructor(private serviceService:ServiceService) {}

    @ApiOperation({ summary: 'Get all services of customer'})
    @Get('/customer/:customerId')
    getServicesByCustomer(@Param()param): object {
      return this.serviceService.getServices(param.customerId) 
    }

    @ApiOperation({ summary: 'Create new service'})
    @Post('/customer/:customerId')
    createNewService(@Param()param,@Body()body:NewServiceRequest): object {
      return this.serviceService.createNewService(param.customerId,body) 
    }



    @ApiOperation({ summary: 'Delete service'})
    @Delete('/:serviceId')
    deleteService(@Param()param): object {
      return this.serviceService.deleteService(param.serviceId) 
    }

    @ApiOperation({ summary: 'Get service types'})
    @Get('/types')
    getServiceTypes(): object {
      return this.serviceService.getServiceTypes() 
    }

    @ApiOperation({ summary: 'Update service'})
    @Patch(':id')
    updateService(@Body()body,@Param()params): object {
      return this.serviceService.updateService(body,params.id)
    }

   
      
   


    
   

}
